
export enum DirectSaleUserMetaSnapshotWsEventResponseDtoEvent {
  DirectSaleUserMetaSnapshot= 'DirectSaleUserMetaSnapshot',

}